// extracted by mini-css-extract-plugin
var _1 = "Dashboard-module__card__qdWAJ";
var _2 = "Dashboard-module__cardDescription__QDpte";
var _3 = "Dashboard-module__cardGrid__c9gaL";
var _4 = "Dashboard-module__cardIcon__HtbJG";
var _5 = "Dashboard-module__cardItem__bMdMB";
var _6 = "Dashboard-module__cardTitle__s_4xB";
var _7 = "Dashboard-module__dashboardHeading__CcGGM";
var _8 = "Dashboard-module__dashboardSection__I6XnF";
export { _1 as "card", _2 as "cardDescription", _3 as "cardGrid", _4 as "cardIcon", _5 as "cardItem", _6 as "cardTitle", _7 as "dashboardHeading", _8 as "dashboardSection" }
